import { DownloadCloudIcon } from "lucide-react";

const HeroTitle = () => {
  return (
    <div className="relative flex items-start gap-3.5 overflow-hidden rounded-2xl bg-[#10192B] p-5 text-[#F3EEE2] mb-5">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] bg-[#1B2740]">
        <DownloadCloudIcon size={18} className="text-[#B8862B]" />
      </div>
      <div>
        <h1 className="mb-1.5 text-[19px] font-extrabold leading-7">
          پشتیبان‌گیری از داده‌ها        </h1>
        {/* <p className="text-[13px] leading-[1.9] text-[#B9C0CE]">
          یک نسخه‌ی اکسل شامل بخش‌های انتخابی از اطلاعات شما ساخته و برای دانلود
          آماده می‌شود.
        </p> */}
      </div>
    </div>
  );
};

export default HeroTitle;
